import ICustomer from '../../../../../../common/interfaces/customer/ICustomer'
import './StatusDetailedAnalysisCompareBar.scss'

type ComponentProps = {
  customer:ICustomer
  title:string
  primaryObjectTitle:string
  primaryObjectScore:number
  secondaryObjectTitle:string
  secondaryObjectScore:number
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
}

const StatusDetailedAnalysisCompareBar = (props:ComponentProps) => {
  
  const borderedPrimaryObjectScore = (props.primaryObjectScore < 1 ? 1 : (props.primaryObjectScore > 9) ? 9 : props.primaryObjectScore)
  const borderedSecondaryObjectScore = (props.secondaryObjectScore < 1 ? 1 : (props.primaryObjectScore > 9) ? 9 : props.primaryObjectScore)
  const primaryLeftStyle = `${10 * Math.round(borderedPrimaryObjectScore)}%`
  const secondaryLeftStyle = `${10 * Math.round(borderedSecondaryObjectScore)}%`

  return (
    <>
      <div className='status-detailed-analysis-comparison-bar'>
        <div className='title'>{props.title}</div>
        <div className='bar-wrapper'>
          <div className='bar'>
            <div className='compare-object primary-object' style={{left: primaryLeftStyle}} title={props.primaryObjectTitle + ' (' + Math.round(props.primaryObjectScore) + '/10)'}>{props.primaryObjectTitle}</div>
            <div className='compare-object secondary-object' style={{left: secondaryLeftStyle}} title={props.secondaryObjectTitle + ' (' + Math.round(props.secondaryObjectScore) + '/10)'}>{props.secondaryObjectTitle}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StatusDetailedAnalysisCompareBar